import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_layout/WMS/auto-replenishment/requests",
)({
  component: AutoReplenishmentRequestsRoute,
})

function AutoReplenishmentRequestsRoute() {
  return <Outlet />
}
